export const ADD_LOGIN_DETAILS = 'ADD_LOGIN_DETAILS';
